import { NETWORKS } from '@/constants'
import { INetworks } from '@/interface'
import { useAppStore } from '@/store'

const ChainsChip = ({ chainLogos }: { chainLogos: Record<string, string> }) => {
  const { network } = useAppStore((state) => state) as any
  const IS_TESTNET = network === INetworks.TESTNET
  const activeChains = Object.values(NETWORKS).filter((chain) => !!chain.testnet === IS_TESTNET)
  return (
    <div className="p-1 pr-2 rounded-full border border-[#EAECF0] bg-white flex items-center gap-2 shrink-0">
      {activeChains.map((chainLogo) => (
        <img src={chainLogos[chainLogo.chainId]} className="w-6 h-6" />
      ))}
    </div>
  )
}
export default ChainsChip
